module.exports = new __parcel__URL__("chevron-up.341e71dd.svg").toString();